import styles from './Contact.module.css';

type ContactProps = {
  email?: string;
  phone?: string;
  profileImageUrl?: string;
};

function Contact({
                   email = 'dev@star-light.space',
                   phone = '010-9379-9431',
                   profileImageUrl = 'https://cdn.star-light.space/profile.jpg'
                 }: ContactProps) {
  return (
    <section className={styles.Contact}>
      <img
        src={profileImageUrl}
        alt="사진"
        className={styles.contactImage}
      />
      <div>
        <ul>
          <li>조은솔 / Cho Eunsol</li>
          <li>92.10.27</li>
          <li><a href={`https://resume.star-light.space/`}>이력서 최신버전 보기</a></li>
        </ul>
        <br/>
        <h4>연락처</h4>
        <ul>
          <li>이메일: <a href={`mailto:${email}`}>{email}</a></li>
          <li>핸드폰: {phone}</li>
          <li>github : <a href="https://github.com/tracy-cho">https://github.com/tracy-cho</a></li>
        </ul>
      </div>
    </section>
  );
}

export {Contact};